import { Image } from "react-bootstrap";
import styled from "styled-components";

export const Container = styled.div`
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: center;
  width: 90%;
  max-width: 1010px;
  column-gap: 16px;

  @media screen and (max-width: 2560px) {
    display: inline-flex;
  }
  @include medium {
    overflow: hidden;
    width: 700px;
  }
  @include small {
    overflow: hidden;
    width: auto;
    overflow: hidden;
    justify-content: flex-start;
  }
  @media only screen and (min-width: 769px) {
    width: 100%;
    column-gap: 24px;
    margin-top: 24px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  padding: 16px;
  align-items: flex-start;
  border-radius: 16px;
  background-color: ${(props) =>
    props?.isActive ? props?.activeBgColor ?? "#fff" : "#fff"};
  width: ${(props) => props?.width};
  border: 1px solid #f0f2f9;
  @media only screen and (min-width: 769px) {
    padding: 12px;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  row-gap: 8px;
`;

export const CardTitle = styled.h1`
  font-size: 13px;
  color: ${(props) => (props?.isActive ? "#fff" : "#6A7481")};
  margin: 0;
  padding: 0 !important;
  line-height: unset;
  font-weight: 700;

  @media only screen and (min-width: 769px) {
    font-size: 28px;
    line-height: 37px;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  border-radius: 50%;
  width: 41px;
  height: 41px;
  background-color: ${(props) =>
    props?.isActive ? props?.iconActiveBgColor ?? "#fff" : "#F0F2F9"};
  overflow: hidden;

  @media only screen and (min-width: 769px) {
    width: 80px;
    height: 80px;
  }
`;

export const CardImage = styled(Image)`
  position: relative;
  width: 36px;
  height: 36px;

  @media only screen and (min-width: 769px) {
    width: 68px;
    height: 68px;
  }
`;

export const CardItemContainer = styled.div``;
